import { useTranslation } from 'react-i18next';
import { Link, Navigate } from 'react-router';
import { useTypedParams } from 'react-router-typesafe-routes';
import Info from '@/assets/images/icons/toast/info.svg?react';
import GroupAdminList from '@/components/groups/group-admin-sectioned-list/group-admin-list';
import PageLayout from '@/components/layouts/page-layout/page-layout';
import useGroupInfo from '@/hooks/groups/use-group-info';
import ROUTES from '@/routes';

export default function GroupAdminRoute() {
  const { t } = useTranslation();
  const { id: groupId } = useTypedParams(ROUTES.MESSAGES.GROUPS.SETTINGS.ADMIN.ADMINS);
  const { canManage, isPending } = useGroupInfo(groupId);

  if (!isPending && !canManage)
    return (
      <Navigate
        to='..'
        replace
      />
    );

  return (
    <PageLayout
      title={t('conversation.setting.group.admin.administrators')}
      className='w-full'
      headerConfig={{
        navigateBack: true,
        actions: (
          <Link
            className='btn btn-ghost btn-sm text-primary mode-embedded:text-primary-content layout-compact:text-primary'
            to={ROUTES.MESSAGES.GROUPS.SETTINGS.ADMIN.ADMINS.$.ADD.$path({ relative: true })}>
            {t('common.add')}
          </Link>
        ),
      }}>
      <GroupAdminList
        className='mt-4 desktop:overflow-y-auto'
        groupId={groupId}
      />

      <div className='flex flex-1 select-none items-end justify-center mb-safe-offset-10 desktop:pt-10'>
        <div className='flex items-start gap-1 rounded-md bg-blue-50 p-2'>
          <Info className='size-4' />
          <p
            className='text-sm'
            // biome-ignore lint/security/noDangerouslySetInnerHtml: safe strings
            dangerouslySetInnerHTML={{ __html: t('conversation.setting.group.admin.privileges') }}
          />
        </div>
      </div>
    </PageLayout>
  );
}
